import { IconProps, iconA11yProps } from '../types';

export const Resend = ({ classNames, label }: IconProps) => (
    <svg className={`${classNames}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
        <path d="M10 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V10.7" />
        <path d="M3 7L12 13L21 7" />
        <path d="M14 22V19H17" />
        <path d="M14.9199 19.8343C15.5869 21.1207 16.9337 22 18.4864 22C20.7023 22 22.4986 20.2091 22.4986 18C22.4986 15.7909 20.7023 14 18.4864 14C17.0013 14 15.7046 14.8044 15.0109 16" />
    </svg>
);
